export const SET_PERMISSIONS="SET_PERMISSIONS";

export const setPermissions=(permissions)=>({
  type:SET_PERMISSIONS,
  payload:permissions
});